var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconDrop = function SvgS2IconDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 450 450"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s2_icon_drop_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h450v450H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s2_icon_drop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeWidth: 26,
    d: "M350.5 313.986c0 62.146-66.01 102.459-125.808 102.459S98.974 376.11 98.974 313.986 167.909 77.2 167.909 77.2s10.677-44.434 56.783-44.434S282.315 77.2 282.315 77.2 350.5 251.84 350.5 313.986Z",
    "data-name": "Path 1007124"
  }))));
};
export default SvgS2IconDrop;